export const USER_PERMISSIONS = {
  CREATE_COURSE: "CREATE_COURSE",
  VIEW_MEETING: "VIEW_MEETING",
  CREATE_MEETING: "CREATE_MEETING",
  EDIT_MEETING: "CREATE_MEETING",
  DELETE_MEETING: "CREATE_MEETING",
  EDIT_SESSION: "EDIT_SESSION",
  DELETE_SESSION: "DELETE_SESSION",
  CREATE_SESSION: "CREATE_SESSION",
  CREATE_USER: "CREATE_USER",
  SYNC_USERS: "SYNC_USERS",
  EDIT_COURSE: "EDIT_COURSE",
  DELETE_COURSE: "DELETE_COURSE",
  VIEW_COURSE: "VIEW_COURSE",
  EXPORT: "EXPORT",
};
